import Vue from 'vue'
import Vuex from 'vuex'
import cookieService from './services/cookieService'

Vue.use(Vuex)

const state = {
  sidebarShow: 'responsive',
  sidebarMinimize: false,
  cookieConsent: {
    showBanner: false,
    showPreferences: false,
    categories: {
      necessary: true,
      analytics: false,
      marketing: false,
      preferences: false
    }
  }
}

const mutations = {
  toggleSidebarDesktop (state) {
    const sidebarOpened = [true, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarOpened ? false : 'responsive'
  },
  toggleSidebarMobile (state) {
    const sidebarClosed = [false, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarClosed ? true : 'responsive'
  },
  set (state, [variable, value]) {
    state[variable] = value
  },
  SET_COOKIE_BANNER_VISIBILITY (state, visible) {
    state.cookieConsent.showBanner = visible
  },
  SET_COOKIE_PREFERENCES_VISIBILITY (state, visible) {
    state.cookieConsent.showPreferences = visible
  },
  SET_COOKIE_CATEGORY (state, { category, value }) {
    if (category !== 'necessary') {
      state.cookieConsent.categories[category] = value
    }
  },
  SET_ALL_COOKIE_CATEGORIES (state, categories) {
    state.cookieConsent.categories = { ...state.cookieConsent.categories, ...categories }
  }
}

const actions = {
  initializeCookieConsent({ commit }) {
    const consent = cookieService.getConsentStatus()
    if (consent) {
      commit('SET_ALL_COOKIE_CATEGORIES', consent.categories)
      cookieService.initializeAnalytics()
      cookieService.initializeMarketing()
    } else {
      commit('SET_COOKIE_BANNER_VISIBILITY', true)
      cookieService.blockNonEssentialCookies()
    }
  },
  acceptAllCookies({ commit }) {
    const categories = {
      necessary: true,
      analytics: true,
      marketing: true,
      preferences: true
    }
    commit('SET_ALL_COOKIE_CATEGORIES', categories)
    commit('SET_COOKIE_BANNER_VISIBILITY', false)
    cookieService.saveConsentStatus(categories)
    cookieService.initializeAnalytics()
    cookieService.initializeMarketing()
  },
  rejectAllCookies({ commit }) {
    const categories = {
      necessary: true,
      analytics: false,
      marketing: false,
      preferences: false
    }
    commit('SET_ALL_COOKIE_CATEGORIES', categories)
    commit('SET_COOKIE_BANNER_VISIBILITY', false)
    cookieService.saveConsentStatus(categories)
  },
  saveCookiePreferences({ commit, state }) {
    commit('SET_COOKIE_BANNER_VISIBILITY', false)
    commit('SET_COOKIE_PREFERENCES_VISIBILITY', false)
    cookieService.saveConsentStatus(state.cookieConsent.categories)
    cookieService.initializeAnalytics()
    cookieService.initializeMarketing()
  },
  openCookiePreferences({ commit }) {
    commit('SET_COOKIE_PREFERENCES_VISIBILITY', true)
  },
  closeCookiePreferences({ commit }) {
    commit('SET_COOKIE_PREFERENCES_VISIBILITY', false)
  }
}

export default new Vuex.Store({
  state,
  mutations,
  actions
})